import { render, staticRenderFns } from "./CotPropostaAccessoProroghePage.vue?vue&type=template&id=77048289"
import script from "./CotPropostaAccessoProroghePage.vue?vue&type=script&lang=js"
export * from "./CotPropostaAccessoProroghePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports